<div class="container-fluid" style="height: calc(100% - 50px); padding: 20px;">
    <div class="d-flex justify-content-between align-items-center">
        <h3>ECL Config</h3>
    </div>

    <div style="height: calc(100% - 100px)">
        <!-- Single state display - handles both loading and empty -->
        <app-state-display
            *ngIf="isLoading || (!isLoading && filteredECLConfig.length === 0)"
            [type]="isLoading ? 'loading' : 'empty'"
            loadingMessage="Loading ECL Config..."
            emptyMessage="No ECL Config found"
            emptyIcon="assignment">
        </app-state-display>

        <!-- Table content -->
        <app-custom-table
            *ngIf="!isLoading && filteredECLConfig.length > 0"
            class="ag-theme-material"
            [rowData]="filteredECLConfig"
            [columnDefs]="columns"
            [animateRows]="true"
            [pagination]="true"
            [hideGlobalFilter]="true"
            [dropdownFilters]="dropdownFilters"
            [paginationAutoPageSize]="true"
            (cellValueChanged)="onCellValueChanged($event)" >
        </app-custom-table>
    </div>
</div>
